import React, { useCallback, useState, useEffect } from "react";
import CommonModal from "../modalLayout/CommonModal";
import { UnloadingSvg } from "../../../svgFiles/UnloadingSvg";
import { WashingSvg } from "../../../svgFiles/WashingSvg";
import TimeIcon from "../../../images/time.svg";
import MangoIcon from "../../../images/mango.svg";
import BrixIcon from "../../../images/brix.svg";
import KgsIcon from "../../../images/kgs.svg";
import CaseIcon from "../../../images/case.svg";
import PalletIcon from "../../../images/pallet.svg";
import ColdStorageIcon from "../../../images/cold-storage.svg";
import RipeningIcon from "../../../images/ripening.svg";
import RejectedIcon from "../../../images/rejected.svg";
import KgCaseIcon from "../../../images/kgCase.svg";
import { GreenTickSvg, RedTickSvg } from "../../../svgFiles/GreenTickSvg";
import "./overview.css";
import useTranslator from "../../../hooks/useTranslator";
import moment from "moment";
import { convertToUserTimezone } from "../../../helpers/Utils";
import { MARGIN_FOR_REJECTED_KG, PROJECT_DATETIME_FORMAT } from "../../../helpers/constants";

const margin_for_rejected_kg = parseFloat(MARGIN_FOR_REJECTED_KG);

const OverviewModal = ({ show, setShow, unloading, mode }) => {
  const [formData, setFormData] = useState(unloading);
  const [footerGreenStrip, setFooterGreenStrip] = useState({});

  const handleClose = () => {
    setShow(false);
  };
  const { _t } = useTranslator();

  const {
    supplier_name,
    case_fresh,
    already_ripened_cases,
    already_ripened_cases_kg,
    ripening_ready_cases,
    ripening_ready_cases_kg,
    rejected_case_count,
    orange_case_kg,
    rejected_case_count_kg,
    batch_code,
    time,
    fruit_name,
    brix_level,
    kg_entered,
    total_cases,
    total_pallets,
    cases_to_cold_storage,
    cases_to_cold_storage_kg,
    total_rejected_kg_actual,
    unloading_date
  } = formData;

  // console.log(unloading)

  const total =
    cases_to_cold_storage_kg +
    ripening_ready_cases_kg +
    already_ripened_cases_kg +
    total_rejected_kg_actual;

  const timeInput = convertToUserTimezone(unloading_date,PROJECT_DATETIME_FORMAT) ;

  useEffect(() => {
    const originalValue = parseFloat(kg_entered);

    const minAllowed = originalValue - originalValue * margin_for_rejected_kg;
    const maxAllowed = originalValue + originalValue * margin_for_rejected_kg;

    if (total < minAllowed || total > maxAllowed) {
      setFooterGreenStrip({
        status: false,
        message: "",
      });
    } else {
      // const percentChange = ((total - originalValue) / originalValue) * 100;
      // const roundedPercent = Math.abs(percentChange.toFixed(2)); // Always positive for display

      // const direction =
      //   percentChange > 0 ? "increased" : percentChange < 0 ? "decreased" : "";

      setFooterGreenStrip({
        status: true,
        message: `Within ±${margin_for_rejected_kg * 100} % variation`,
      });
    }
  }, []);

  // End

  // Common Functions
  //============================================
  const getTotalPalletKg = (receiving_pallets = []) => {
    return receiving_pallets.reduce(
      (sum, p) => sum + parseFloat(p.pallet_kg_entered || 0),
      0
    );
  };

  const getAreaPallets = (area) => {
    if (area != "") {
      return (
        formData?.ripening_pallets.filter(
          (pallet) => pallet.pallet_area == area
        ) || []
      );
    }
    return formData?.pallets || [];
  };

  const getAreaPalletsKg = (area) => {
    const pallets = getAreaPallets(area);
    return getTotalPalletKg(pallets);
  };

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={_t("adding_washing_data", "Adding Washing Data")}
      headerInfo="true"
      headername={supplier_name}
      BatchCode={batch_code}
    >
      <h4 className="overViewtitle">
        {UnloadingSvg} {_t("unloading_data", "Unloading Data")}
      </h4>
      <ul className="overviewGrid mb-4">
        <li className="overviewGrid_card">
          {" "}
          <img src={TimeIcon} alt="" />
          {_t("date", "Date")} : <span>{timeInput}</span>
        </li>
        <li className="overviewGrid_card">
          {" "}
          <img src={MangoIcon} alt="" />
          {_t("fruit_type", "Fruit Type")} : <span>{fruit_name}</span>
        </li>
        <li className="overviewGrid_card">
          {" "}
          <img src={BrixIcon} alt="" />
          {_t("brix_level", "Brix Level")} : <span>{brix_level}</span>
        </li>
        <li className="overviewGrid_card">
          {" "}
          <img src={KgsIcon} alt="" />
          {_t("kg_entered", "Kg Entered")} : <span>{kg_entered}</span>
        </li>
        <li className="overviewGrid_card">
          {" "}
          <img src={CaseIcon} alt="" />
          {_t("cases", "Cases")} : <span>{total_cases}</span>
        </li>
        <li className="overviewGrid_card">
          {" "}
          <img src={PalletIcon} alt="" />
          {_t("pallets", "Pallets")} : <span> {total_pallets}</span>
        </li>
      </ul>

      <div className={`washingData ${mode === "unloading" ? "blur" : ""}`}>
        <h4 className="overViewtitle">
          {WashingSvg} {_t("washing_data", "Washing Data")}
        </h4>
        <ul className="overviewGrid washingGrid mb-0">
          {/* <li className="overviewGrid_card">
            {" "}
            <img src={ColdStorageIcon} alt="" />
            {_t("cold_stored", "Cold Stored")} :{" "}
            <span>
              {cases_to_cold_storage} {_t("cases", "Cases")} /{" "}
              {cases_to_cold_storage_kg} {_t("kg", "Kg")}
            </span>
          </li> */}
          {/* <li className="overviewGrid_card">
            {" "}
            <img src={KgCaseIcon} alt="" />
            {_t("kg_per_case_fresh", "KG/Case Fresh")}{" "}
            <span> {case_fresh}</span>
          </li> */}
          {/* <li className="overviewGrid_card">
            {" "}
            <img src={RipeningIcon} alt="" />
            {_t("ripening", "Ripening")} :{" "}
            <span>
              {ripening_ready_cases} {_t("cases", "Cases")} /{" "}
              {ripening_ready_cases_kg} {_t("kg", "KG")}
            </span>
          </li> */}
          {/* <li className="overviewGrid_card">
            {" "}
            <img src={KgCaseIcon} alt="" />
            {_t("kg_per_orange_case", "KG/Orange Case")} :{" "}
            <span>{orange_case_kg}</span>
          </li> */}
          {/* <li className="overviewGrid_card">
            {" "}
            <img src={RipeningIcon} alt="" />
            {_t("already_ripened", "Already Ripened")} :{" "}
            <span>
              {already_ripened_cases} {_t("cases", "Cases")} /{" "}
              {already_ripened_cases_kg} {_t("kg", "KG")}
            </span>
          </li> */}
          {/* <li className="overviewGrid_card">
            {" "}
            <img src={KgCaseIcon} alt="" />
            Orange Case Inc.% : <span></span>
          </li> */}
          {/* <li className="overviewGrid_card">
            {" "}
            <img src={RejectedIcon} alt="" />
            {_t("rejected", "Rejected")}:{" "}
            <span>
              {rejected_case_count} {_t("cases", "Cases")} /{" "}
              {rejected_case_count_kg} KG
            </span>
          </li> */}
          <li className="overviewGrid_card">
            {" "}
            <img src={KgCaseIcon} alt="" />
            {_t("kg_after_wash", "Kg After Wash")}{" "}
            <span>
              {" "}
              {formData?.kg_after_wash} {_t("kg", "KG")}
            </span>
          </li>
          <li className="overviewGrid_card">
            {" "}
            <img src={RejectedIcon} alt="" />
            {_t("rejected", "Rejected")}:{" "}
            <span>
              {rejected_case_count} {_t("cases", "Cases")} /{" "}
              {total_rejected_kg_actual}
               ({rejected_case_count_kg} <small>{_t("expected","Expected")})</small>{_t("kg", "KG")}
            </span>
          </li>
        </ul>

        <div className="pallets_list mt-3">
          {/* <h6>{_t("added_pallets", "Added Pallets")}</h6> */}
          {getAreaPallets("cold_storage").length > 0 && (
            <div className="pallet_card">
              <div className="pallets_head d-flex align-items-center justify-content-between">
                <h5 className="mb-0">{_t("cold_storage", "Cold Storage")}</h5>{" "}
                <span>
                  {_t("total_kg", "Total KG")}:{" "}
                  {getAreaPalletsKg("cold_storage")} {_t("kg", "Kg")}
                </span>
              </div>
              <ul className="p-0 m-0">
                {getAreaPallets("cold_storage").map((pallet, index) => {
                  return (
                    <li className="pallet_data" key={index}>
                      <ul className="p-0 d-flex m-0">
                        <li className="w-100">
                          {index === 0 && (
                            <span className="d-block pallet_heading">
                              {_t("id", "Id")}
                            </span>
                          )}
                          <span className="d-block">{index + 1}</span>
                        </li>
                        <li className="w-100">
                          {index === 0 && (
                            <span className="d-block pallet_heading">
                              {_t("pallet_code", "Pallet Code")}
                            </span>
                          )}
                          <span className="d-block">
                            {pallet.pallet.pallet_name}
                          </span>
                        </li>
                        <li className="w-100">
                          {index === 0 && (
                            <span className="d-block pallet_heading">
                              {_t("weight", "Weight")}
                            </span>
                          )}
                          <span className="d-block">
                            {pallet.pallet_kg_entered} {_t("kg", "Kg")}
                          </span>
                        </li>
                        <li className="w-100">
                          {index === 0 && (
                            <span className="d-block pallet_heading">
                              {_t("cases", "Cases")}
                            </span>
                          )}
                          <span className="d-block">
                            {pallet.pallet_total_cases} {_t("cases", "Cases")}
                          </span>
                        </li>
                      </ul>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          {getAreaPallets("ripening").length > 0 && (
            <div className="pallet_card">
              <div className="pallets_head d-flex align-items-center justify-content-between">
                <h5 className="mb-0">{_t("ripening", "Ripening")}</h5>{" "}
                <span>
                  {_t("total_kg", "Total KG")}: {getAreaPalletsKg("ripening")}{" "}
                  {_t("kg", "Kg")}
                </span>
              </div>
              <ul className="p-0 m-0">
                {getAreaPallets("ripening").map((pallet, index) => {
                  return (
                    <li className="pallet_data" key={index}>
                      <ul className="p-0 d-flex m-0">
                        <li className="w-100">
                          {index === 0 && (
                            <span className="d-block pallet_heading">
                              {_t("id", "Id")}
                            </span>
                          )}
                          <span className="d-block">{index + 1}</span>
                        </li>
                        <li className="w-100">
                          {index === 0 && (
                            <span className="d-block pallet_heading">
                              {_t("pallet_code", "Pallet Code")}
                            </span>
                          )}
                          <span className="d-block">
                            {pallet.pallet.pallet_name}
                          </span>
                        </li>
                        <li className="w-100">
                          {index === 0 && (
                            <span className="d-block pallet_heading">
                              {_t("weight", "Weight")}
                            </span>
                          )}
                          <span className="d-block">
                            {pallet.pallet_kg_entered} {_t("kg", "Kg")}
                          </span>
                        </li>
                        <li className="w-100">
                          {index === 0 && (
                            <span className="d-block pallet_heading">
                              {_t("cases", "Cases")}
                            </span>
                          )}
                          <span className="d-block">
                            {pallet.pallet_total_cases} {_t("cases", "Cases")}
                          </span>
                        </li>
                        <li className="w-100">
                          {index === 0 && (
                            <span className="d-block pallet_heading">
                              {_t("room", "Room")}
                            </span>
                          )}
                          <span className="d-block">
                            {`${_t("room", "Room")} ${pallet.pallet_room_id}`}
                          </span>
                        </li>
                      </ul>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          {getAreaPallets("sorting").length > 0 && (
            <div className="pallet_card">
              <div className="pallets_head d-flex align-items-center justify-content-between">
                <h5 className="mb-0">{_t("sorting", "Sorting")}</h5>{" "}
                <span>
                  {_t("total_kg", "Total KG")}: {getAreaPalletsKg("sorting")}{" "}
                  {_t("kg", "Kg")}
                </span>
              </div>
              <ul className="p-0 m-0">
                {getAreaPallets("sorting").map((pallet, index) => {
                  return (
                    <li className="pallet_data" key={index}>
                      <ul className="p-0 d-flex m-0">
                        <li className="w-100">
                          {index === 0 && (
                            <span className="d-block pallet_heading">
                              {_t("id", "Id")}
                            </span>
                          )}
                          <span className="d-block">{index + 1}</span>
                        </li>
                        <li className="w-100">
                          {index === 0 && (
                            <span className="d-block pallet_heading">
                              {_t("pallet_code", "Pallet Code")}
                            </span>
                          )}
                          <span className="d-block">
                            {pallet.pallet.pallet_name}
                          </span>
                        </li>
                        <li className="w-100">
                          {index === 0 && (
                            <span className="d-block pallet_heading">
                              {_t("weight", "Weight")}
                            </span>
                          )}
                          <span className="d-block">
                            {pallet.pallet_kg_entered} {_t("kg", "Kg")}
                          </span>
                        </li>
                        <li className="w-100">
                          {index === 0 && (
                            <span className="d-block pallet_heading">
                              {_t("cases", "Cases")}
                            </span>
                          )}
                          <span className="d-block">
                            {pallet.pallet_total_cases} {_t("cases", "Cases")}
                          </span>
                        </li>
                      </ul>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>
        <div>
          <ul
            className={`totalData ${footerGreenStrip.status ? "" : "notequal"}`}
          >
            <li>{footerGreenStrip.status ? GreenTickSvg : RedTickSvg}</li>

            <li>
              <strong>
                {kg_entered} {_t("kg", "KG")}
              </strong>
              <span>({_t("total_entered", "Total Entered")})</span>
            </li>
            <li>=</li>
            <li>
              <strong>
                {cases_to_cold_storage_kg} {_t("kg", "KG")}
              </strong>
              <span> ({_t("cold_stored", "Cold Stored")}) </span>
            </li>
            <li>+</li>
            <li>
              <strong>
                {ripening_ready_cases_kg} {_t("kg", "KG")}
              </strong>
              <span>({_t("ripening", "Ripening")}) </span>
            </li>
            <li>+</li>
            <li>
              <strong>
                {already_ripened_cases_kg} {_t("kg", "KG")}
              </strong>
              <span> ({_t("already_ripened", "Already Ripened")}) </span>
            </li>
            <li>+</li>
            <li>
              <strong>
                {total_rejected_kg_actual }<small>({rejected_case_count_kg} {_t("expected","Expected")})</small>
                {_t("kg", "KG")}
              </strong>
              <span>({_t("rejected", "Rejected")}) </span>

              {/* {footerGreenStrip.message && (
                <span>
                  <small>
                    {footerGreenStrip.message ? footerGreenStrip.message : ""}
                  </small>
                </span>
              )} */}
            </li>
          </ul>
        </div>
      </div>
    </CommonModal>
  );
};

export default OverviewModal;
const time12hr = (time) => {
  console.log(time);
  const [hours, minutes, seconds] = time.split(":");
  const hour = parseInt(hours, 10);
  const period = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${hour12}:${minutes} ${period}`;
};


